enum BodyType {
  StationCar = 'stationCar',
  Hatchback = 'hatchback',
  Sedan = 'sedan',
  SUV = 'suv',
  Coupe = 'coupe',
  Cabriolet = 'cabriolet',
  Pickup = 'pickUp',
  MPV = 'mpv',
  Van = 'van',
}

export default BodyType;
